import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { AppLayout } from '../../layouts';

/**
 * PaymentCancelView - Page affichée après annulation du paiement Stripe
 * 
 * Cette page est affichée quand l'utilisateur annule le paiement sur Stripe Checkout
 * ou ferme la fenêtre de paiement.
 */
const PaymentCancelView: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <AppLayout>
            <div className="container-fluid d-flex align-items-center justify-content-center bg-dark" style={{ minHeight: '100vh' }}>
                <div className="card border-0 shadow-lg" style={{ maxWidth: '500px', backgroundColor: '#1a1a1a' }}>
                    <div className="card-body text-center p-5">
                        {/* Icône d'annulation */}
                        <div className="mb-4">
                            <div 
                                className="rounded-circle mx-auto d-flex align-items-center justify-content-center"
                                style={{ width: '80px', height: '80px', backgroundColor: '#6c757d' }}
                            >
                                <i className="fa-solid fa-times text-white fs-1"></i>
                            </div>
                        </div>

                        {/* Titre */}
                        <h1 className="text-white mb-3">
                            {t('views.payment.cancel.title')}
                        </h1>

                        {/* Description */}
                        <p className="text-light fs-5 mb-4" style={{ color: '#e9ecef !important' }}>
                            {t('views.payment.cancel.description')}
                        </p>

                        {/* Message d'assistance */}
                        <div className="alert alert-warning mb-4" style={{ backgroundColor: '#fff3cd', border: '1px solid #ffeaa7', color: '#856404' }}>
                            <i className="fa-solid fa-lightbulb me-2"></i>
                            {t('views.payment.cancel.help')}
                        </div>

                        {/* Actions */}
                        <div className="d-grid gap-3">
                            <button
                                className="btn btn-primary btn-lg"
                                onClick={() => navigate('/pricing')}
                                style={{ backgroundColor: '#0d6efd', borderColor: '#0d6efd' }}
                            >
                                <i className="fa-solid fa-credit-card me-2"></i>
                                {t('views.payment.cancel.retryPayment')}
                            </button>
                            
                            <button
                                className="btn btn-outline-light"
                                onClick={() => navigate('/dashboard/home')}
                                style={{ borderColor: '#6c757d', color: '#e9ecef' }}
                            >
                                <i className="fa-solid fa-tachometer-alt me-2"></i>
                                {t('views.payment.cancel.gotoDashboard')}
                            </button>
                            
                            <button
                                className="btn btn-outline-info"
                                onClick={() => navigate('/contact')}
                                style={{ borderColor: '#17a2b8', color: '#17a2b8' }}
                            >
                                <i className="fa-solid fa-envelope me-2"></i>
                                {t('views.payment.cancel.contactSupport')}
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </AppLayout>
    );
};

export default PaymentCancelView;
